import { api } from '@shared-runtime/api';

import type { UploadDocumentsParams, UploadDocumentsResult } from './apiSchema';
import { normalizeUploadDocuments } from './helpers';
import type { UploadDocumentsResponse } from './schema';

export async function fetchUploadDocuments(
  params: UploadDocumentsParams,
): Promise<UploadDocumentsResponse> {
  return api.nts
    .post<UploadDocumentsResult>('/fiat/documents', params)
    .normalize(normalizeUploadDocuments);
}
